/** Firestore rejects document fields whose value is `undefined`. */
export function stripUndefinedFields<T extends Record<string, unknown>>(data: T): T {
  const result = { ...data };
  for (const key of Object.keys(result)) {
    if (result[key] === undefined) {
      delete result[key];
    }
  }
  return result;
}
